var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.7,
    d: "M9.571.5A1.93 1.93 0 0 1 11.5 2.429v4.285a1.93 1.93 0 0 1-1.929 1.929v.928l-.007.147a1.43 1.43 0 0 1-1.275 1.275L8.143 11H2.429l-.147-.007a1.43 1.43 0 0 1-1.274-1.275L1 9.57V3.857c0-.74.562-1.347 1.282-1.42l.147-.008h.928A1.93 1.93 0 0 1 5.287.5zM2.43 3.429a.43.43 0 0 0-.43.428v5.714c0 .237.192.429.429.429h5.714a.43.43 0 0 0 .428-.429V3.857a.43.43 0 0 0-.428-.428zM5.286 1.5a.93.93 0 0 0-.929.929h3.786l.146.008c.72.073 1.282.68 1.282 1.42v3.786a.93.93 0 0 0 .929-.93V2.43a.93.93 0 0 0-.929-.929z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.559fd693343c1dad071d55eef10b75fe.svg";
export { ForwardRef as ReactComponent };